exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reservations-panel {\n  border: 1px solid #DBDFE2;\n  border-radius: 4px;\n}\n.reservations-tabs__container + .reservations-panel,\n.reservations-tabs__container + div .reservations-panel {\n  border-top-left-radius: 0;\n  border-top: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-31c76cb2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/reservations/ReservationsTabs.vue
// module id = 2784
// module chunks = 0